<template>
	 <v-container style="z-index:10000;padding: 0;">
		 <v-dialog title="课次详情" v-model="hideShow" width="800px" persistent>
			<v-card min-height="400">
				<v-card-title>
					<span>课程详情页</span>
					<v-spacer></v-spacer>
					<v-icon @click="cancel">mdi-close-circle</v-icon>
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="mt-4" v-if="record">
					<v-row dense >
						<v-col cols="12" class="d-flex">
							<v-btn color="info" :disabled="record.status !=='1'" class="mr-1" small @click="toShowApprove">核销</v-btn>
							<v-btn color="info" :disabled="record.status !=='1'" class="mr-1" small @click="toShowUpdate">修改</v-btn>
							<v-btn color="info" :disabled="record.status !=='1'" class="mr-1" small @click="frozenRecord">删除</v-btn>
							<v-btn color="info" :disabled="record.status !=='1'" class="mr-1" small @click="delayRecord">顺延</v-btn>
							<v-btn color="info" :disabled="record.status !=='3'" class="mr-1" small @click="undoDelayRecord">撤销顺延</v-btn>
							<v-btn color="info" :disabled="record.status !=='2'" class="mr-1" small @click="showCancelApprove">撤销核销</v-btn>
							
							<!-- 校区开启了约课功能 -->
							<template v-if="record.shopAllowBook=='1' && record.status == '1' ">
								<v-btn color="success" class="mr-1" small @click="toShowBook">约课设置</v-btn>
							</template>
							<!-- <v-btn color="info" :disabled="record.status !=='2'" class="mr-1" small @click="showBatchRate">批量点评</v-btn> -->
						</v-col>
					</v-row>
					<v-row dense class="mt-2">
						<v-col cols="4">
							<span>课程名称:</span>
							<span class="ml-1">{{record.courseName}}</span>
						</v-col>
						<v-col cols="4">
							<span>班级名称:</span>
							<span class="ml-1">{{record.className}}</span>
						</v-col>
						<v-col cols="4">
							<span>课程日期:</span>
							<span class="ml-1">{{record.classDate}}</span>
						</v-col>
					</v-row>
					<v-row dense class="mt-2">
						<v-col cols="4">
							<span>上课时间:</span>
							<span class="ml-1">{{record.timeFrom}}-{{record.timeTo}}</span>
						</v-col>
						<v-col cols="4">
							<span>任课老师:</span>
							<span class="ml-1">{{record.teacherName}}</span>
						</v-col>
						<v-col cols="4">
							<span>教室:</span>
							<span class="ml-1">{{record.roomName}}</span>
						</v-col>
					</v-row>
					<template v-if="record.isAllowBook=='1'">
						<v-row dense class="mt-2" >
							<v-col cols="4">
								<span>课程模式:</span>
								<span class="ml-1" style="color: green;font-weight: 600;">约课</span>
							</v-col>
							<v-col cols="4">
								<span>最大约课人数:</span>
								<span class="ml-1">{{record.maxBookQty}}</span>
							</v-col>
							<v-col cols="4">
								<span>已约课人数:</span>
								<span class="ml-1">{{record.bookCount}}</span>
							</v-col>
						</v-row>
					</template>
					<v-row dense class="mt-2">
						<v-col cols="4">
							<span>课程状态:</span>
							<span v-if="record.status =='1'" class="ml-1" style="color:#FF9100">待核销</span>
							<span v-if="record.status =='2'" class="ml-1" style="color:green">已核销</span>
							<span v-if="record.status =='3'" class="ml-1" style="color:#43A047;">已顺延</span>
						</v-col>
						<v-col cols="4">
							<span>扣费方式:</span>
							<span class="ml-1" v-if="record.approveConsumeType=='1'">按课时核销</span>
							<span class="ml-1" v-if="record.approveConsumeType=='2'">按金额核销</span>
						</v-col>
						<v-col cols="4">
							
						</v-col>
					</v-row>
					<v-row  v-if="record.status =='2'" dense class="mt-2">
						<v-col cols="4">
							<span>应/实/假/旷:</span>
							<span class="ml-1">{{record.unionCount}}</span>
						</v-col>
						<v-col cols="4">
							<span>核销扣除:</span>
							<span v-if="record.approveConsumeType ==='2'">{{record.totalReduceFee}}元</span>
							<span v-else>{{record.totalReduceQty}}课时</span>
						</v-col>
						<v-col cols="4">
							<span>消课收入:</span>
							<span class="ml-1">{{record.totalRevenue}}元</span>
						</v-col>
					</v-row>
					<v-divider class="mt-2"></v-divider>
					<!-- 班级学员 -->
					<v-row v-if="record.status =='1'&& record.classStudentList" dense>
						<v-col cols="12" class="mt-2">
							<span style="font-size: 16px; font-weight: 400;color:black;">班级学员({{record.classStudentList.length}})：</span>
						</v-col>
						<template v-if="record.classStudentList.length==0">
							<v-col cols="12">暂无班级成员</v-col>
						</template>
						<v-col cols="12" class="d-flex flex-wrap ml-1 mt-n1">
							<div v-for="(item,index) in record.classStudentList" :key="index" class="d-flex align-center mr-2 mb-2"
								style="height: 60px; width: 180px; background-color: #eeeeee; border-radius: 10px;">
								<!-- <v-avatar color="orange" class="ml-2">
									<v-img :src="global.config.imgPre+item.studentAvatar"></v-img>
								</v-avatar> -->
								<div class="ml-2 d-flex flex-column">
									<!-- <span class="mr-3" style="color:black">{{item.studentName}}</span> -->
									<div>
										<span style="color:black">{{item.studentName}}</span>
										<template v-if="record.approveConsumeType=='2'">
											<span style="color: red;" class="ml-2">{{item.classPrice}}元/课时</span>
										</template>
										
									</div>
									<div>
										<span class="mr-1">入班日期:</span>
										<span>{{item.joinDate}}</span>
									</div>
								</div>
							</div>
						</v-col>
					</v-row>
					<!-- 插班补课学员 -->
					<v-row v-if="record.status =='1'&& record.extraStudentList && record.extraStudentList.length > 0" dense>
						<v-col cols="12" class="mt-2">
							<span style="font-size: 16px; font-weight: 400;color:black;">插班补课学员({{record.extraStudentList.length}})：</span>
						</v-col>
						<v-col cols="12" class="d-flex flex-wrap ml-1 mt-n1">
							<div v-for="(item,index) in record.extraStudentList" :key="index" class="d-flex align-center mr-2 mb-2 justify-space-between"
								style="height: 60px; width: 180px; background-color: #eeeeee; border-radius: 10px;">
								
								<div class="ml-2 d-flex flex-column">
									<div>
										<span style="color:black">{{item.studentName}}</span>
										<template v-if="record.approveConsumeType=='2'">
											<span style="color: red;" class="ml-2">{{item.recordPrice}}元/课时</span>
										</template>
									</div>
									<div>
										<span style="font-size: 12px;">缺课日期:{{item.missClassDate}}</span>
									</div>
								
								</div>
								<v-icon color="error" class="mr-1" @click="removeExtraStudent(item)">mdi-close-circle</v-icon>
							</div>
						</v-col>
					</v-row>
					<!-- 约课学员 -->
					<template v-if="record.isAllowBook =='1' && record.status =='1'">
						<v-row v-if="record.bookStudentList">
							<v-col cols="12">
								<span style="font-size: 16px; font-weight: 400;color:black;">已约课学员({{record.bookStudentList.length}})：</span>
								<v-btn color="info" small class="mt-n1" @click="showAddBookStudent">添加</v-btn>
							</v-col>
							<template v-if="record.bookStudentList.length==0">
								<v-col cols="12">暂无约课成员</v-col>
							</template>
							<v-col cols="12" class="d-flex flex-wrap ml-1 mt-n3">
								<div v-for="(item,index) in record.bookStudentList" :key="index" class="d-flex align-center mr-2 mb-2 justify-space-between"
									style="height: 60px; width: 180px; background-color: #eeeeee; border-radius: 10px;">
									
									<div class="ml-2 d-flex flex-column" @click="showUpdateBookPrice(item)" style="cursor: pointer;">
										<div>
											<span style="color:black">{{item.studentName}}</span>
											<template v-if="record.approveConsumeType=='2'">
												<span style="color: red;" class="ml-2">{{item.recordPrice}}元/课时</span>
											</template>
										</div>
										<div>
											<span style="font-size: 12px;">{{item.createAt}}</span>
										</div>
									</div>
									<v-icon color="error" class="mr-1" @click="removeBookStudent(item)">mdi-close-circle</v-icon>
								</div>
							</v-col>
							<v-col cols="12">
								
							</v-col>
						</v-row>
					</template>

					<!-- 核销明细 -->
					<v-row v-if="record.status =='2' && record.approvedDetailList" >
						<v-col cols="12" class="mt-2">
							<span style="font-size: 16px; font-weight: 400;color:black;">核销明细：</span>
						</v-col>
						<v-col cols="12" class="d-flex flex-wrap ml-1">
							<div v-for="(item,index) in record.approvedDetailList" :key="index" class="d-flex align-center mr-2 mb-2"
								style="height: 60px; width: 180px; background-color: #eeeeee; border-radius: 10px;">
								<!-- <v-avatar color="orange" class="ml-2">
									<v-img :src="global.config.imgPre+item.studentAvatar"></v-img>
								</v-avatar> -->
								<div class="ml-2" style="width:90%;cursor:pointer" @click="showUpdateRecord(item)">
									<div class="d-flex justify-space-between">
										<span style="color:#000000">{{item.studentName}}</span>
										
										<span v-if="item.status == '1'" style="color:green">到课</span>
										<span v-if="item.status == '2'" style="color:red">请假</span>
										<span v-if="item.status == '3'">旷课</span>
									</div>
									<div class="mt-1">
										
										<span v-if="item.consumeType ==='1'">扣课时:</span>
										<span v-if="item.consumeType ==='1'" class="pl-1">{{item.reduceQty}}课时</span>
										<span v-if="item.consumeType ==='2'">扣金额:</span>
										<span v-if="item.consumeType ==='2'" class="pl-1">{{item.reduceAmount}}元</span>
										<template v-if="item.studentType=='2'">
											<v-chip small color="success" outlined class="ml-2">约</v-chip>
										</template>
										<template v-if="item.studentType=='3'">
											<v-chip small color="error" outlined class="ml-2">补</v-chip>
										</template>
									</div>
									
								</div>
								
							</div>
						</v-col>
						
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>
		
		<!-- 核销组件 -->
		<approveRecord :show="approveCom.show" :recordId="approveCom.recordId" @cancel="approveCom.show=false" @success="approveSuccess"></approveRecord>
		<!-- 修改课次组件 -->
		<updateRecord :show="updateCom.show" :record="updateCom.record" @cancel="updateCom.show=false" @success="updateSuccess"></updateRecord>
		<!-- 撤销核销组件 -->
		<cancelApproveRecord :show="cancelApprove.show" :recordId="cancelApprove.recordId" @cancel="cancelApprove.show=false" @success="cancelApproveSuccess"></cancelApproveRecord>
		<!-- 约课设置组件 -->
		<recordBookSetting :show="bookCom.show" :record="bookCom.record" @cancel="bookCom.show=false" @success="bookSetSuccess"></recordBookSetting>
		<!-- 添加约课学员 -->
		<recordBookAddStudent :show="addBookStudent.show" :record="addBookStudent.record" @cancel="addBookStudent.show=false" @success="addBookStudentSuccess"></recordBookAddStudent>
		<!-- 修改约课学员消课价格 -->
		<updateRecordBookPrice :show="updateBookPrice.show" :bookStudent="updateBookPrice.bookStudent" @cancel="updateBookPrice.show=false" @success="updateBookPriceSuccess"></updateRecordBookPrice>
		<!-- 修改核销明细 -->
		<updateApprovedRecordDetail :show="updateRecordDialog.show" :recordDetail="updateRecordDialog.recordDetail" @cancel="updateRecordDialog.show=false" @success="updateRecordSuccess"></updateApprovedRecordDetail>
		
	 </v-container>
</template>

<script>
	import global from "../config/global"
	import approveRecord from "./approve_record.vue"
	import updateRecord from "./class_record_update.vue"
	import cancelApproveRecord from "./cancel_approve_record.vue"
	import recordBookSetting from "./record_book_setting.vue"
	import recordBookAddStudent from "./record_book_add_student.vue"
	import updateRecordBookPrice from "./update_record_book_price.vue"
	import updateApprovedRecordDetail from "./update_approved_record_detail.vue"
	export default {
		name:"record-info",
		components:{approveRecord,updateRecord,cancelApproveRecord,recordBookSetting,recordBookAddStudent,updateRecordBookPrice,updateApprovedRecordDetail},
		props: {
			//显示/隐藏。
			show: {
				type: Boolean,
				default: false
			},
			recordId:{
				type:String,
				default:null
			}
			
		},
		watch:{
			show(newVal,oldVal){
				console.log("newVal",newVal);
				this.hideShow = newVal;
				if(this.hideShow){
					this.normalStudentList = [];
					this.getRecordDetail();
				}
			}
		},
		data(){
			return {
				global:global,
				hideShow:this.show,
				record:null,
				normalStudentList:[],
				approveCom:{
					show:false,
					recordId:""
				},
				updateCom:{
					show:false,
					record:null
				},
				cancelApprove:{
					show:false,
					recordId:""
				},
				bookCom:{
					show:false,
					record:null
				},
				addBookStudent:{
					show:false,
					record:null
				},
				updateBookPrice:{
					show:false,
					bookStudent:null
				},
				updateRecordDialog:{
					show:false,
					recordDetail:null
				}
			}
		},
		mounted() {
			console.log("record-info-view mounted");
		},
		methods:{
			statusName(state) {
				let stName = "未知";
				if (state === "1") {
					stName = "待核销";
				} else if (state === "0") {
					stName = "已取消";
				}else if (state === "2") {
					stName = "已核销";
				}else if (state === "3") {
					stName = "已顺延";
				}
				return stName;
			},
			statusColor(state) {
				let color = "";
				if (state === "1") {
					color = "info";
				} else if (state === "0") {
					color = "error";
				}else if (state === "2") {
					color = "success";
				}else if (state === "3") {
					color = "grey";
				}
			
				return color;
			},
			cancel(){
				this.$emit("cancel","");
			},
			toShowApprove(){
				this.approveCom.recordId = this.recordId;
				this.approveCom.show = true;
			},
			toShowUpdate(){
				this.updateCom.record = this.record;
				this.updateCom.show = true;
			},
			approveSuccess(){
				this.getRecordDetail();
				this.approveCom.show= false;
				
			},
			updateSuccess(){
				this.getRecordDetail();
				this.updateCom.show = false;
			},
			showCancelApprove(){
				this.cancelApprove.recordId = this.recordId;
				this.cancelApprove.show = true;
			},
			cancelApproveSuccess(){
				this.getRecordDetail();
				this.cancelApprove.show = false;
			},
			frozenRecord(){
				// 取消排课记录
				const that = this;
				let url = `/edu/class/record/frozen/${this.record.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getRecordDetail();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			delayRecord(){
				// 顺延排课记录
				const that = this;
				let url = `/edu/class/record/delay/${this.record.id}`;
				this.axios.post(url).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getRecordDetail();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			undoDelayRecord(){
				// 撤销顺延排课记录
				const that = this;
				let url = `/edu/class/record/delay/undo`;
				
				let postData = [this.record.id];
				this.axios.post(url,postData).catch(() => {
					that.$noty.error('操作失败');
				}).then(res => {
					if (res && res.data) {
						if (res.data["code"] === 200) {
							that.$noty.success("操作成功");
							that.getRecordDetail();
							return;
						}else{
							that.$noty.error("操作失败," + res.data["message"]);
							return;
						}
					} else {
						that.$noty.error('远程请求失败');
					}
				
				});
			},
			getRecordDetail(){
			
				const recordId = this.recordId;
				// 获取校区学生列表
				if (!recordId) {
					return
				}
							
				const that = this;
				let url = `/edu/record/detail/` + recordId;
							
				this.axios.get(url).then(response => {
							
					if (response.data["code"] === 200) {
						let resData = response.data["data"] ? response.data["data"] : null;
						
						that.record = resData;
						
						console.log(resData);
					
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
							
					
				})
			},
			toShowBook(){
				// 开启约课
				console.log("open book");
				this.bookCom.show=true;
				this.bookCom.record = this.record;
			},
			showBatchRate(){
				// 批量点评
				
			},
			closeBook(){
				// 关闭约课
				console.log("close book");
			},
			bookSetSuccess(){
				// 约课设置成功
				this.getRecordDetail();
				this.bookCom.show = false;
			},
			showAddBookStudent(){
				this.addBookStudent.record = this.record;
				this.addBookStudent.show= true;
			},
			addBookStudentSuccess(){
				// 添加约课学员成功
				this.getRecordDetail();
				this.addBookStudent.show = false;
			},
			removeBookStudent(item){
				// 删除约课成员
				console.log(item);
				
	
				const that = this;
				let url = `/edu/record/book/student/remove/` + item.id;
							
				this.axios.post(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						this.getRecordDetail();
					
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
							
					
				})
			},
			showUpdateBookPrice(item){
				
				if(this.record && this.record.approveConsumeType === "2"){
					this.updateBookPrice.bookStudent = item;
					this.updateBookPrice.show=true;
				}
				
			},
			updateBookPriceSuccess(e){
				this.getRecordDetail();
				this.updateBookPrice.show=false;
			},
			removeExtraStudent(item){
				// 删除补课学员
				console.log(item);
				const that = this;
				let url = `/edu/record/extra/student/remove/` + item.id;
							
				this.axios.post(url).then(response => {
							
					if (response.data["code"] === 200) {
						
						this.getRecordDetail();
					
						return
					}else{
						that.$noty.error("获取失败：" + response.data["message"]);
					}
							
					
				})
			},
			showUpdateRecord(item){
				console.log(item);
				this.updateRecordDialog.recordDetail = item;
				this.updateRecordDialog.show=true;
			},
			updateRecordSuccess(){
				this.updateRecordDialog.show = false;
				this.getRecordDetail();
			}
			
		}
	}
	
</script>

<style>
</style>
